export default __webpack_public_path__ + "static/media/diversity5.229cede4.webp";